export default __webpack_public_path__ + "static/media/UM.e834167e.svg";